import { Chip } from '@heroui/react';

interface TabCountBadgeProps {
  count: number;
  color?: 'accent' | 'success' | 'danger' | 'warning' | 'default';
}

export function TabCountBadge({ count, color = 'accent' }: TabCountBadgeProps) {
  if (count <= 0) return null;

  return (
    <Chip
      size="sm"
      variant="primary"
      color={color}
      className="min-h-5 min-w-5 px-1.5 text-xs font-semibold tabular-nums"
    >
      {count}
    </Chip>
  );
}
